/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'sarsaparilla';
import { dateSelectionProps } from '../../props/DateSelection';
import PreferredDatesItem from './PreferredDatesItem';

const propTypes = {
    seasonStart: PropTypes.string,
    seasonEnd: PropTypes.string,
    selections: PropTypes.arrayOf(dateSelectionProps),
    onChange: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    allowMore: PropTypes.bool,
    isCommercialUser: PropTypes.bool,
    pActions: PropTypes.shape({
        updatePendingReservation: PropTypes.func.isRequired,
        formValidationChange: PropTypes.func.isRequired,
    }).isRequired,
    validation: PropTypes.object.isRequired,
    onValidatedDateItems: PropTypes.func,
    displayValidationError: PropTypes.bool,
};

const defaultProps = {
    allowMore: true,
};

export default class PreferredDatesList extends Component {
    render() {
        const lotteryPreferenceType = '';
        return (
            <div className="per-preferred-dates-list">
                <div className="per-form-group">
                    {this.props.selections.map((selection, idx) => {
                        const validationErrors = {
                            choiceRequired: `Choice #${idx + 1}: Choice is required`,
                        };
                        return (
                            <PreferredDatesItem
                                displayValidationError={this.props.displayValidationError}
                                onValidated={this.props.onValidatedDateItems}
                                seasonStart={this.props.seasonStart}
                                seasonEnd={this.props.seasonEnd}
                                selection={selection}
                                onChange={(value) => this.props.onChange(idx, value)}
                                onRemove={this.props.onRemove}
                                index={idx}
                                key={`date-${selection.id}`}
                                validationErrors={validationErrors}
                                lotteryPreferenceType={lotteryPreferenceType}
                                availability={this.props.availability}
                                validation={this.props.validation}
                                reservation={this.props.reservation}
                                pActions={this.props.pActions}
                                isCommercialUser={this.props.isCommercialUser}
                            />
                        );
                    })}
                </div>
                <Button
                    appearance="link"
                    iconBeforeElement={<Icon iconName="add-circle" />}
                    onClick={this.props.onAdd}
                    isDisabled={!this.props.allowMore}
                    className="addAnotherChoiceLink"
                >
                    Add another choice
                </Button>
            </div>
        );
    }
}

PreferredDatesList.propTypes = propTypes;
PreferredDatesList.defaultProps = defaultProps;
